class TopbarModel {
  constructor() {
    this.customerName = '';
    this.customerSince = '';
    this.selectedLanguage = {
      'key' : '',
      'language' : '',
    };
    this.notifications = [];
  }

  get notificationsCount() {
    let count = 0;

    angular.forEach(this.notifications, (value, key) => {
      if (!value.isRead) {
        count++;
      }
    });

    return count;
  }

  markNotificationsAsRead() {
    angular.forEach(this.notifications, (value, key) => {
      value.isRead = true;
    });
  }
}

export default TopbarModel;



// WEBPACK FOOTER //
// ./client/app/shared/ui/topbar/topbar.model.js